import { Component, ChangeDetectorRef, ElementRef,OnDestroy, input, output, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from '../../../app.service';
import { AuthenticationService } from '../../../services/AuthenticationService';
import { Subscription } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { Property } from '../../../models/property';
import { PropertyService } from '../../../services/PropertyService';
import { NavigationEnd, Router } from '@angular/router';
import { AppConfig } from '../../../app.config';
import { PropertyFilterParameters } from '../../../models/propertyFilterParameters';

@Component({ standalone: false,
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnDestroy {
  readonly showPropertySearchByScroll = input<boolean>(false);
  readonly onMenuIconClick = output<any>();

  public searchForm: FormGroup;
  public filteredAutoCompleteOptions?: Property[];
  public searchOverlayOpen:boolean=false;

  private showPropertySearchByUrl:boolean=false;
  private authenticatedSubscription:Subscription;
  private sub?:Subscription;
  private skipFilter:boolean = false;

  constructor(private elementRef:ElementRef, private cdRef: ChangeDetectorRef,private appService:AppService, private authService:AuthenticationService, private propertyService:PropertyService, private router:Router, private appConfig:AppConfig) { 
    this.searchForm = new FormGroup({
      searchString:new FormControl<string|undefined>(undefined)
    });this.showPropertySearchByUrl=!(router.url==='/' || router.url==='/login' || router.url==='/register');
    this.authenticatedSubscription=this.authService.authenticatedSubject.subscribe(()=>{
      this.cdRef.detectChanges();
    });
    this.router.events.subscribe((event)=>{ 
      if(event instanceof NavigationEnd){
        this.showPropertySearchByUrl=!(event.url==='/' || event.url==='/login' || event.url==='/register');
        this.searchOverlayOpen=false;
      }
    });
  }

  ngOnInit(){
    //hook up auto complete filter
    this.sub = this.searchForm.get('searchString')!.valueChanges
    .pipe(
      startWith(''),
      map(value => {
          if(!this.skipFilter){
            this.filter(value);
          }
      })
    ).subscribe();
  }

  ngOnDestroy(){
    if(this.sub) this.sub.unsubscribe();
    this.authenticatedSubscription.unsubscribe();
  }

  get compareVisible (){
    return this.appConfig.compareVisible;
  }

  get showPropertySearch(){
    return this.showPropertySearchByUrl || this.showPropertySearchByScroll();
  }

  public sidenavToggle(){
    this.onMenuIconClick.emit(undefined);
  }

  public openSearchOverlay(){
    this.searchOverlayOpen=true;
    //focus the input once the overlay is rendered so the phone keyboard opens right away
    setTimeout(()=>(this.elementRef.nativeElement as HTMLElement).querySelector<HTMLInputElement>('.search-overlay input')?.focus());
  }

  public closeSearchOverlay(){
    this.searchOverlayOpen=false;
  }

  public searchInputKeyDown($event:any){
    this.skipFilter=false;
  }

  private filter(value: string){
    const filterValue = value?value.toLowerCase():undefined;
    this.propertyService.getProperties().pipe(take(1)).subscribe(pa=>{
      if(filterValue?.length){
        this.filteredAutoCompleteOptions = pa?.filter(option => filterValue?option.searchInfo.toLowerCase().includes(filterValue):true);
      }
      else{
        this.filteredAutoCompleteOptions=pa;
      }
    });
  }

  public onSearchItemSelected(pfp:PropertyFilterParameters){
    this.searchOverlayOpen=false;
    if(pfp.propertySearch?.goDirect && pfp.propertySearch.propertyIds?.length){
      this.router.navigate(['/properties/'+pfp.propertySearch.propertyIds[0]]);
    }
    else{
      this.appService.setPresetPropertyFilterParameters(pfp, true)
      this.router.navigate(['/properties']);
    }
  }

  get authenticated(){
    return this.authService.authenticated;
  }

  get favoriteProperties(){
    return this.appService.favoriteProperties;
  }

  get comparableProperties(){
    return this.appService.compareProperties;
  }

  get toDoCount(){
    return this.authService.currentUserValue?.unverifiedAgentIds?.length;
  }

  get isSuperAdmin(){
    return this.authService.currentUserValue?.role=='SuperAdmin';
  }

}